import { ReactNode } from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Stack,
  Container,
  Avatar,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  block_dark_back_color,
  block_ligth_back_color,
  font_color,
} from "../../../constants/style";

const photo =
  "data:image/jpeg;base64,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";

const Testimonial = ({ children }: { children: ReactNode }) => {
  return <Box>{children}</Box>;
};

const TestimonialContent = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      bg={block_ligth_back_color}
      boxShadow={"lg"}
      p={8}
      rounded={"xl"}
      align={"center"}
      pos={"relative"}
      _after={{
        content: `""`,
        w: 0,
        h: 0,
        borderLeft: "solid transparent",
        borderLeftWidth: 16,
        borderRight: "solid transparent",
        borderRightWidth: 16,
        borderTop: "solid",
        borderTopWidth: 16,
        borderTopColor: block_ligth_back_color,
        pos: "absolute",
        bottom: "-16px",
        left: "50%",
        transform: "translateX(-50%)",
      }}
      minH={"170px"}
    >
      {children}
    </Stack>
  );
};

const TestimonialHeading = ({ children }: { children: ReactNode }) => {
  return (
    <Heading as={"h3"} fontSize={"xl"}>
      {children}
    </Heading>
  );
};

const TestimonialText = ({ children }: { children: ReactNode }) => {
  return (
    <Text textAlign={"center"} color={font_color} fontSize={"sm"}>
      {children}
    </Text>
  );
};

const TestimonialAvatar = ({
  src,
  name,
  title,
}: {
  src: string;
  name: string;
  title: string;
}) => {
  return (
    <Flex align={"center"} mt={8} direction={"column"}>
      <Avatar src={src} mb={2} boxSize={"100px"} />
      <Stack spacing={-1} align={"center"}>
        <Text fontWeight={600}>{name}</Text>
        <Text fontSize={"sm"} color={font_color}>
          {title}
        </Text>
      </Stack>
    </Flex>
  );
};

export default function () {
  return (
    <Box id="leaders">
      <Flex py={20}>
        <Box bg={block_dark_back_color} borderRadius={10} mx={"auto"} p={5}>
          <Container maxW={"4xl"} py={8} as={Stack} spacing={12}>
            <Stack spacing={0} textAlign={"center"}>
              <Heading>Эксперты и кураторы Клуба264</Heading>
              <Text>с радостью ответят на Ваши вопросы</Text>
            </Stack>
            <Stack
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 10, md: 4, lg: 10 }}
            >
              <Testimonial>
                <TestimonialContent>
                  <TestimonialHeading>
                    <Text textAlign={"center"}>
                      Преподаватель СУДЭКС, СПБПУ и Санкт-Петербургского
                      Института Адвокатуры
                    </Text>
                  </TestimonialHeading>
                  <TestimonialText>
                    адвокат АП Санкт-Петербурга, эксперт-автотехник,
                    видеотехник, трасолог
                  </TestimonialText>
                </TestimonialContent>
                <TestimonialAvatar
                  src={
                    "https://www.apspb.ru/upload/medialibrary/a1f/a1fbb3f281241dc62d2a261738a9839b.jpg"
                  }
                  name={"Аркадий Келарев"}
                  title={"эксперт и куратор Клуба264"}
                />
              </Testimonial>
              <Testimonial>
                <TestimonialContent>
                  <TestimonialHeading>
                    <Text textAlign={"center"}>
                      PR-директор Института Адвокатуры
                    </Text>
                  </TestimonialHeading>
                  <TestimonialText>адвокат АП Санкт-Петербурга</TestimonialText>
                </TestimonialContent>
                <TestimonialAvatar
                  src={
                    "https://www.apspb.ru/upload/medialibrary/673/673be3fb39a47bce91e0053eef601b60.jpg"
                  }
                  name={"Ольга Шушминцева"}
                  title={"куратор Клуба264"}
                />
              </Testimonial>
            </Stack>
          </Container>
        </Box>
      </Flex>
    </Box>
  );
}
